import fetch from '../utils/fetch';

//   获取轨迹点
export function getUserTrajectory(params) {
    return fetch({
        method: 'POST',
        url: '/area/getUserArea',
        data:params
    })
}

// 分页获取轨迹记录信息
export function getTrajectoryList(params) {
    return fetch({
        method: 'POST',
        url: '/trajectory/getTrajectoryList',
        data:params
    })
}

// 获取单个用户的动态轨迹
export function getOnlyTrajectory(params) {
    return fetch({
        method: 'POST',
        url: '/trajectory/getOnlyTrajectory',
        data:params
    })
}

// 获取级动组织机构数据
export function getLinkedOrgData(params) {
    return fetch({
        method: 'POST',
        url: '/organ/organTree/v1',
        data:params
    })
}
